class lityClone {

  constructor() {
    this.ytbPlayer = null

    this.init()
  }

  init() {

    this.initHtml()

    if (!window.__ytbIsReady) {
      $(window).on('onYouTubeIframeAPIReady', () => {
        this.initPlayer()
      })
    } else {
      this.initPlayer()
    }

  }

  eventHandle() {
    $(window.document).on('click', '.js-video-item', ev => {
      let el = ev.currentTarget
      let videoId = el.dataset.videoId

      // 谨严修改 2018/5/17
      $('#slide-nano').find('.trailer-videos-item').map((i, value) => {
        $(value).removeClass('active');
        $(value).children('.js-video-item').attr('data-video-id') == videoId ? $(value).addClass('active').siblings('.trailer-videos-item').removeClass('active') : false;
      });

      if ($(el).hasClass('hideList')) {
        $('#g2-video-box #button-arrow').addClass('hide')
      } else {
        $('#g2-video-box #button-arrow').removeClass('hide')
      }

      window.player && window.player.mute && window.player.mute() // 暂停音乐播放

      //  切换分享链接
      let obj = $('.lity-share').get(0)
      let host = `https://${window.location.host}${window.location.pathname}`
      let num = $(el).parents('.trailer-videos-item').eq(0).index()
      obj.dataset.a2aUrl = `${host}?type=trailer&num=${num}`

      this.ytbPlayer.loadVideoById(videoId)

      this.setPlayerPosition()

      $('#g2-video-box').modal('show')
      $('#jy-screen').addClass('hide');
    })

    $(window).resize(() => {
      this.setPlayerPosition()
    })

    $('.lity-close').on('click', () => $('#g2-video-box').modal('hide'))
    $('#button-arrow').on('click', () => {
      if ($('body').attr('is_rtl') === 'true') {
        $('#slide-center').velocity('transition.slideLeftBigIn', {
          duration: 400
        })
      } else {
        $('#slide-center').velocity('transition.slideRightBigIn', {
          duration: 400
        })
      }

      $('#slide-nano').find('.trailer-videos-item').velocity("transition.slideUpBigIn", {
        stagger: 250
      })
    })
    $('.slide-close').on('click', () => {
      if ($('body').attr('is_rtl') === 'true') {
        $('#slide-center').velocity('transition.slideLeftBigOut', {
          duration: 300
        })
      }else{
        $('#slide-center').velocity('transition.slideRightBigOut', {
          duration: 300
        })
      }
      
    })
  }

  setPlayerPosition() {
    if (this.ytbPlayer) {
      let winWidth = window.innerWidth > 1920 ? 1920 : window.innerWidth
      let iWidth = winWidth * 0.8
      let iHeight = iWidth * 0.5625

      if (iHeight > window.innerHeight) {
        iHeight = window.innerHeight - 88
        iWidth = (16 * iHeight) / 9
      }

      if (window.innerWidth < 980) {
        iWidth = window.innerWidth
        iHeight = iWidth * 0.5625
      }

      this.ytbPlayer.setSize(iWidth, iHeight)

    }
  }

  initPlayer() {
    this.ytbPlayer = new YT.Player('g2-video-player', {
      height: 0,
      width: 0,
      playerVars: {
        'autoplay': 1,
        'controls': 1,
        'rel': 0,
        'showinfo': 0,
        'modestbranding': 1,
        // 'iv_load_policy': 3,
        // 'wmode': 'transparent',
        // 'enablejsapi': 1
      },
      suggestedQuality: 'hd1080',
      videoId: '',
      events: {
        'onStateChange': event => {
          if (event.data === 0) {
            // this.ytbPlayer.seekTo(0)
          }
        }
      }
    })


    this.eventHandle()
  }

  initHtml() {
    $(document.body).append(`
      <div class="modal fade" id="g2-video-box">
            <div id="g2-video-player-wrap"><div id="g2-video-player"></div></div>
            <button class="lity-close" type="button" aria-label="Close (Press escape to close)" data-lity-close="">×</button>
      </div>
    `)

    $('#g2-video-box').append($('#button-arrow').removeClass('hide'))
    $('#g2-video-box').append($('#slide-center').removeClass('hide'))

    $('#g2-video-player-wrap').append($('.lity-share').removeClass('hide').addClass('hidden-lg'))


    window.setTimeout(() => {
      $('#slide-center .trailer-img-default').map((k, el) => {
        let src = el.dataset.src
        el.src = src
      })
    }, 500)

    $('#g2-video-box').on('hidden.bs.modal', () => {
      this.ytbPlayer && this.ytbPlayer.stopVideo()
      $('#slide-center').hide()
      if (!$('.audio-ctrl').hasClass('ft')) {
        window.player && window.player.unMute && window.player.unMute()
      }
      $('#jy-screen').removeClass('hide');
    })

  }

}

export default lityClone